import { CommunicationAlertDto, CommunicationAlertEntity } from "../domain/communicationAlert.entity";
import { IHttpClient } from "../../../lib/http";
import { generateBase58uuid } from "../../witadmin/CRUD/utils";

function entityToDto(entity: CommunicationAlertEntity): CommunicationAlertDto {
  return {
    limiteAvisoDisponibilidad: entity.limiteAvisoDisponibilidad,
    emailAvisoDispo: entity.emailAvisoDispo,
  };
}

function dtoToEntity(dto: CommunicationAlertDto): CommunicationAlertEntity {
  return {
    id: generateBase58uuid(),
    limiteAvisoDisponibilidad: dto.limiteAvisoDisponibilidad || "0",
    emailAvisoDispo: dto.emailAvisoDispo,
  };
}

function buildUrlParams(): URLSearchParams {
  const dto: CommunicationAlertDto = {
    limiteAvisoDisponibilidad: "",
    emailAvisoDispo: "",
  };
  const params = new URLSearchParams();
  Object.keys(dto).forEach(k => params.append("prop", k));
  return params;
}

export async function getCommunicationAlert(
  httpClient: IHttpClient,
  propertyTicker: string
): Promise<CommunicationAlertEntity> {
  const params: URLSearchParams = buildUrlParams();
  const communicationAlertDto: CommunicationAlertDto = await httpClient.get<CommunicationAlertDto>(
    `/WitBookerAPI-war/webresources/endpoint/establishment/${propertyTicker}/configurations`,
    { params }
  );
  return dtoToEntity(communicationAlertDto);
}

export async function updateCommunicationAlert(
  propertyTicker: string,
  entity: CommunicationAlertEntity,
  httpClient: IHttpClient
): Promise<void> {
  await httpClient.post(
    `/WitBookerAPI-war/webresources/endpoint/establishment/${propertyTicker}/createOrUpdateConfigurations`,
    entityToDto(entity)
  );
}
